import { render, staticRenderFns } from "./checkBoxGroup.vue?vue&type=template&id=5fa24316&"
import script from "./checkBoxGroup.vue?vue&type=script&lang=js&"
export * from "./checkBoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports